import type { SVGProps } from 'react';

const DashboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={18}
    height={18}
    fill='none'
    {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M2.25 2.25h6v7.5h-6v-7.5Zm7.5 0h6v4.5h-6v-4.5Zm-3 6v-4.5h-3v4.5h3Zm7.5 6v-4.5h-3v4.5h3Zm-7.5-1.5v1.5h-3v-1.5h3Zm7.5-9v1.5h-3v-1.5h3Zm1.5 4.5h-6v7.5h6v-7.5Zm-13.5 3h6v4.5h-6v-4.5Z'
      clipRule='evenodd'
    />
  </svg>
);

export default DashboardIcon;
